import { MarkdownRenderer } from "$root/components/MarkdownRenderer/MarkdownRenderer";
import { AgGridTooltipWrapper } from "$root/third-party-integrations/ag-grid/ag-grid";
import type { CustomCellRendererProps } from "ag-grid-react";

export function markdownColDef<T>(): {
	cellRenderer: (e: CustomCellRendererProps<T, string | undefined, any>) => React.JSX.Element | string;
	tooltipRender: (e: CustomCellRendererProps<T, string | undefined>) => React.JSX.Element | string;
} {
	function cellRenderer(e: CustomCellRendererProps<T, string | undefined>): React.JSX.Element | string {
		if (!e.value) {
			return "";
		}

		return <MarkdownRenderer className="[&>div]:truncate">{e.value}</MarkdownRenderer>;
	}

	function tooltipRender(e: CustomCellRendererProps<T, string | undefined>): React.JSX.Element | string {
		if (!e.value) {
			return "";
		}
		return (
			<AgGridTooltipWrapper className="min-w-[224px] max-w-[320px] max-h-[320px]">
				<MarkdownRenderer>{e.value}</MarkdownRenderer>
			</AgGridTooltipWrapper>
		);
	}

	return { cellRenderer, tooltipRender };
}
